<template>
  <div
    v-if="$store.state.auth.statusAccounts === 0"
    class="login bg-primary fill-height"
  >
    <v-layout
      v-if="$store.state.language"
      justify-end
      class="pa-2"
      style="position: fixed; right: 0"
    >
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            text
            color="secondary"
            dark
            v-bind="attrs"
            v-on="on"
            class="pa-2 py-4"
            height="0"
          >
            <div class="pr-3">
              <v-img
                width="20"
                :src="'/lang/flags/' + $store.state.language + '.svg'"
              />
            </div>
            <small>{{ $store.state.language.replace("_", "-") }}</small>
            <div class="pl-1">
              <v-icon small>mdi-menu-down</v-icon>
            </div>
          </v-btn>
        </template>
        <v-list min-width="100">
          <v-list-item
            v-for="(item, i) in $store.state.languages"
            :key="i"
            @click="onChangeLanguage(item.flag)"
          >
            <v-list-item-title class="d-flex align-center justify-start">
              <div class="pr-3">
                <v-img width="20" :src="'/lang/flags/' + item.flag + '.svg'" />
              </div>
              <div>
                <small>{{ item.lang }}</small>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-layout>
    <v-layout align-center justify-center fill-height>
      <login-form
        :on-request="signIn"
        :on-response="response"
        :img-logo="cliente.imgLogo"
      />
    </v-layout>
  </div>
</template>

<script>
import LoginForm from "@/components/forms/login-form";
import MixinGlobal from "@/mixins";
export default {
  mixins: [MixinGlobal],
  metaInfo: {
    titleTemplate: "Login | %s",
  },
  components: { LoginForm },
  computed: {
    cliente() {
      return this.$store.state.cliente.data || {};
    },
  },
  mounted() {
    const localLang = navigator.language.toLowerCase().replace("-", "_");

    if (
      !this.$store.state.language &&
      this.$store.state.languages.some((e) => e.flag === localLang)
    ) {
      this.$store.commit("setLanguage", localLang);
    } else if (!this.$store.state.language) {
      this.$store.commit("setLanguage", "en");
    }

    this.$store.dispatch("auth/check").then(() => {
      if (this.$store.state.auth.user && this.$store.state.auth.user.token) {
        this.goToHome();
      }
    });
  },
  methods: {
    onChangeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
    },
    goToHome() {
      switch (this.$store.state.context) {
        case "pessoa":
          return this.$router.push("/");
        case "pet":
          return this.$router.push("/pet");
        case "tagFuncionario":
          return this.$router.push("/tag");
      }
    },
    async signIn({ email, password }) {
      return await this.$store.dispatch("auth/login", {
        email,
        password,
      });
    },
    response(res, err) {
      if (!res || !res.status || res.status >= 500)
        return err("erro desconhecido");
      else if (!res || !res.status || res.status >= 400)
        return err(this.$t("usuario_senha_invalido_tente_novamente"));

      if (res.status === 200) {
        this.$store.commit("setContext", res.data.content.user.tipo);
        this.$store.commit(
          this.$store.state.context + "/setUID",
          res.data.content.user.uid
        );
        this.$store.commit("auth/setAccounts", []);

        this.onChangeLanguage(res.data.content.user.idioma);

        switch (this.$store.state.context) {
          case "pessoa":
            return this.$router.push("/");
          case "pet":
            return this.$router.push("/pet");
          case "tagFuncionario":
            return this.$router.push("/tag");
        }
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
.login {
  &-card {
    min-height: 450px;
  }
}
</style>
